module.exports = __webpack_public_path__ + "img/img26.00aab606.png";